var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationInMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.926,
    height: 34.18,
    viewBox: "0 0 23.926 34.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16704",
    "data-name": "Group 16704",
    transform: "translate(-21.037 -277.551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24403",
    "data-name": "Path 24403",
    d: "M21.963,4A11.965,11.965,0,0,0,10,15.963C10,24.935,21.963,38.18,21.963,38.18S33.926,24.935,33.926,15.963A11.965,11.965,0,0,0,21.963,4Zm0,16.235a4.272,4.272,0,1,1,4.272-4.272A4.274,4.274,0,0,1,21.963,20.235Z",
    transform: "translate(11.037 273.551)",
    fill: "#a5a5a5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationInMap);
export default __webpack_public_path__ + "static/media/locationInMap.2f3aaf87435679cc65c6cd535116ec5b.svg";
export { ForwardRef as ReactComponent };